import styled from 'styled-components';

export const DropZoneS = styled.div`
  padding: 12px;
  background-color: ${props =>
    props.isDragActive
      ? props.theme.colors.backgroundLightGray
      : props.theme.colors.white};
  border: 1px dashed ${props =>
    props.isDragActive
      ? props.theme.colors.borderBlue
      : props.theme.colors.borderGray};
  border-radius: 4px;
  transition: all 0.3s ease-out;
  &:focus {
    outline: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/attachments/drop-zone/styles.js